
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M67.936 30.522c3.099 0 5.908-2.417 6.398-5.503.257-1.616-.152-3.152-1.152-4.325-.98-1.148-2.449-1.807-4.031-1.807-3.099 0-5.909 2.417-6.4 5.504-.256 1.616.154 3.152 1.154 4.324.979 1.148 2.449 1.807 4.031 1.807zM66.7 25.019c.181-1.136 1.325-2.132 2.448-2.132.416 0 .768.144.988.404.232.271.316.652.245 1.1-.18 1.135-1.323 2.131-2.448 2.131-.414 0-.767-.144-.988-.404-.231-.272-.316-.652-.245-1.099zM29.589 66.084a2 2 0 0 0 1.975 2.314h61.551c.982 0 1.82-.715 1.976-1.687 1.65-10.375-.394-19.548-5.754-25.829-4.897-5.739-12.457-8.772-21.86-8.772-7.649 0-14.384 2.309-19.992 6.028-.045-.003-.088-.014-.133-.014H21.769a2 2 0 0 0 0 4h20.674a40.907 40.907 0 0 0-2.604 2.666H4.018a2 2 0 0 0 0 4h32.664a43.576 43.576 0 0 0-2.925 4.834H10.018a2 2 0 0 0 0 4h21.918c-1.103 2.79-1.898 5.64-2.347 8.46zm37.888-29.972c8.313 0 14.646 2.479 18.817 7.369 4.24 4.968 6.058 12.521 5.079 20.917H33.99c3.244-14.114 15.586-28.286 33.487-28.286zm-7.575 4.613c-7.998 2.606-14.733 8.672-17.577 15.83a1.999 1.999 0 0 0 1.121 2.596c.242.099.492.144.738.144.795 0 1.548-.479 1.859-1.262 2.379-5.988 8.307-11.29 15.1-13.503a1.997 1.997 0 0 0 1.281-2.521 1.997 1.997 0 0 0-2.522-1.284zm36.907 31.713c-.879-.983-2.135-1.526-3.535-1.526H28.7c-2.695 0-5.143 2.103-5.571 4.787-.223 1.399.152 2.795 1.03 3.821.876 1.027 2.139 1.595 3.553 1.595h64.651c2.695 0 5.143-2.104 5.582-4.875.166-1.445-.238-2.795-1.136-3.802zm-4.446 4.675h-64.65c-.231 0-.403-.064-.511-.189-.118-.139-.162-.352-.123-.598.129-.811.962-1.416 1.621-1.416h64.571c.174 0 .41.033.552.191.13.145.183.387.159.596-.128.811-.961 1.416-1.619 1.416z"}})])
          )
        }
      }
    